import systemApi from "api/systemApi";

export const postUploadFileMulti = async (data: any = {}) => {
  try {
    const response = await systemApi.postUploadFileMulti(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const getConfiguration = async (params: any = {}) => {
  try {
    const response = await systemApi.getConfiguration(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const putConfiguration = async (data: any = {}) => {
  try {
    const response = await systemApi.putConfiguration(data);
    return response;
  } catch (error) {
    return error;
  }
};